var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoDashboard',{attrs:{"dashboardID":7,"showLoadingState":false,"title":_vm.$t('labels.checkins')}})}
var staticRenderFns = []

export { render, staticRenderFns }